import { Card, PageHeader } from '@safepos/ui';

/** Alamat situs pemasaran dari alamat Back Office (app.contoh.com → contoh.com); null bila tidak dapat diturunkan. */
const siteUrl = (): string | null => {
  const { protocol, hostname } = window.location;
  return hostname.startsWith('app.') ? `${protocol}//${hostname.slice(4)}` : null;
};

const link = 'link-brand';

/** Kredit perangkat lunak & aset pihak ketiga (wajib oleh lisensi CC BY 4.0 / SIL OFL). */
export function AboutPage() {
  const site = siteUrl();
  return (
    <>
      <PageHeader
        title="Tentang & lisensi"
        subtitle="Kredit untuk aset dan perangkat lunak pihak ketiga"
      />
      <Card title="Kredit">
        <ul className="list-disc space-y-2 pl-5 text-sm">
          <li>
            Ikon:{' '}
            <a
              className={link}
              href="https://github.com/480-Design/Solar-Icon-Set"
              target="_blank"
              rel="noopener noreferrer"
            >
              Solar Icon Set
            </a>{' '}
            © 480 Design, lisensi{' '}
            <a
              className={link}
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC BY 4.0
            </a>
            . Ikon dikonversi menjadi komponen React.
          </li>
          <li>
            Font: Inter © The Inter Project Authors, lisensi{' '}
            <a
              className={link}
              href="https://openfontlicense.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              SIL OFL 1.1
            </a>
            .
          </li>
          <li>
            Perangkat lunak sumber terbuka lain dipakai di bawah lisensi masing-masing (MIT, ISC,
            Apache-2.0, BSD).
          </li>
        </ul>
        {site && (
          <p className="mt-4 text-sm">
            <a className={link} href={`${site}/lisensi/`} target="_blank" rel="noopener noreferrer">
              Daftar lengkap lisensi pihak ketiga
            </a>
          </p>
        )}
      </Card>
    </>
  );
}
